import React, { useRef } from 'react'
import Axios from "axios"
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router'
import '../assets/style/Login.css';
import { Link } from 'react-router-dom';
import { Centralizer, TextField, Container, Button, Group, Grid } from '../components';
import { useTranslate } from '../hooks';
// import BASE_URL from "../utils/Variables/baseURL"
import { ConfirmResetContainer } from '../components';
import { jwtDecode } from 'jwt-decode';
import passwordValidate from '../utils/passwordValidate';

type locationProps = {
  state: {
    username?: string
  },
  search?: string
}

type messageType = {
  text?: string,
  css?: string
}

const ResetPassword = () => {
  const { token } = useParams();
  const { t } = useTranslate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);

  //Variables for ResetPassword without /Token
  const [username, setUsername] = useState('')
  const [message, setMessage] = useState<messageType>();
  const [buttonClicked, setButtonClicked] = useState(false)
  const [showButton, setShowButton] = useState(true)
  const [ isNewUser, setIsNewUser ] = useState(false)
  const passwordRef = useRef<HTMLInputElement>(null);

  //Variables with /Token
  const [password, setPassword] = useState('')
  const [repeatedPassword, setRepeatedPassword] = useState('')

  useEffect(() => {    
    if (location.state?.username) setUsername(location.state.username)
    else if(token) {
      const r = jwtDecode(token) as any
      if(r?.username) setUsername(r.username)
    }
    if(queryParams.get("initial") == "1") setIsNewUser(true)
  }, [location])

  const navigate = useNavigate()

  useEffect(() => {
    if(!passwordValidate(password)) setMessage({})
  }, [username, password, repeatedPassword])

  const sendResetMail = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage({})
    setButtonClicked(true)
    Axios.post(`${process.env.REACT_APP_BASE_URL}/resetPassword`, { username },
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        timeout: 5000
      })
      .then(_ => {
        setShowButton(false)
      })
      .catch((e) => {
        let msg = e?.response?.data?.message ?? e.message
        setMessage({
          text: t(`errorTexts.${msg}`, undefined, msg),
          css: "text-red-600"
        })
        setButtonClicked(false)
      })
  }

  const changePassword = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const err = passwordValidate(password)
    if(err) return setMessage({text: t(err), css: "text-red-600"})

    setMessage({})
    setButtonClicked(true)

    if (password !== repeatedPassword) {
      setMessage({
        text: t("passwordsNotIdentical"),
        css: "text-red-600"
      })
      setButtonClicked(false)
      return
    }

    Axios.post(`${process.env.REACT_APP_BASE_URL}/changePassword`, {
      resetToken: token,
      password
    },
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        timeout: 5000
      })
      .then(response => {
        setShowButton(false)
        let seconds = 5
        let intervalId = setInterval(() => {
          seconds--
          setMessage({ text: t("passwordUpdated", {seconds:seconds.toString()}) })
          if (seconds === 0) {
            clearInterval(intervalId)
            return navigate("/Login", { state: { username } })
          }
        }, 1000)
      })
      .catch((e) => {
        console.error(e)
        let msg = e?.response?.data?.message ?? e.message
        setMessage({
          text: t(`errorTexts.${msg}`, undefined, msg),
          css: "text-red-600"
        })
        setButtonClicked(false)
      })
  }

  return (
    <>{!token ?
      <ConfirmResetContainer username={username} showLoginLink={true}>
        <form onSubmit={(e) => sendResetMail(e)}>
          {showButton ?
            <>
              <TextField autoFocus _type="email" required value={username} onChange={(e) => setUsername(e.target.value)}>{t("email")}</TextField>
              <Button className="schipt-btn primary" disabled={buttonClicked} style={{ marginTop: "2.3rem" }}>{t("resetPassword")}</Button>
            </>
            :
            <h3>{t("sentPasswordResetMail")}</h3>
          }
        </form>
        {message?.text ?
          <p className={`text-ms mt-2 ${message?.css ?? ''} font-bold`} style={{ position: "absolute" }} >{message?.text}</p>
          : <></>
        }
      </ConfirmResetContainer>
      :
      <ConfirmResetContainer username={username} showLoginLink={true}>
        <form onSubmit={(e) => changePassword(e)}>
          <TextField 
            autoFocus 
            _type="password"
            required 
            _ref={passwordRef}
            value={password} 
            onChange={(e) => setPassword(e.target.value)}
            error={(!!password && passwordValidate(password) ? t("validation.invalidPassword") : undefined)}
            onBlur={(e) => {
              const err = passwordValidate(e.target.value)
              if(err) setMessage({text: t(err), css: "text-red-600"})
            }}
          >{isNewUser ? t("password"): t("newPassword")}</TextField>
          <TextField 
            _type="password" 
            required 
            value={repeatedPassword} 
            onChange={(e) => setRepeatedPassword(e.target.value)}
            error={!!repeatedPassword && repeatedPassword != password ? t("passwordsNotIdentical"): undefined}
          >{t("repeatPassword")}</TextField>
          <Button disabled={buttonClicked} style={{ marginTop: "2.3rem" }}>{isNewUser ? t("confirm"): t("resetPassword")}</Button>
          {message?.text ?
            <p className={`text-ms mt-2 ${message?.css ?? ""} font-bold whitespace-pre-wrap`}>{message?.text}</p>
            : <></>
          }
        </form>
      </ConfirmResetContainer>
    }</>
  )
}
export default ResetPassword